import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

export interface GiphyComponentDataProps {
    url: string;
    width: number;
    height: number;
    description: string;
    dataId?: string;
}

type GiphyComponentProps = GiphyComponentDataProps & MandatoryAdditionalStyle;

const getStyle = (width: number, height: number) => {
  return StyleSheet.create({
    figure: {
      position: 'relative',
      overflow: 'hidden',
      margin: 0,
      boxSizing: 'border-box',
      flex: '1 1 100%',
      minWidth: '0%',
      paddingTop: `calc(100% / (${width / height}))`,
    },
    image: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
    },
  });
};

export const GiphyComponent: React.FunctionComponent<GiphyComponentProps> = props => {
  const { additionalStyle, url, width, height, description, dataId } = props;
  const style = getStyle(width, height);

  return (
    <div data-id={dataId} className={css(additionalStyle.style)}>
      <figure className={css(style.figure)}>
        <img src={url} className={css(style.image)} alt={description} />
      </figure>
    </div>
  );
};

export const Giphy = (props: GiphyComponentProps) => <ErrorBoundary><GiphyComponent {...props} /></ErrorBoundary>;
